import React from 'react'
import type { EventGQL } from '../../../../Api'
import { PLL_LINKS } from '../../../../Config/config'
import {
  getShortDate,
  getReverseBroadcastImg,
  getGameTimeLocal,
} from '../../../../Utils'
import {  WhiteButtonLink } from '../../../../Components/Buttons'
import { BrocastLogoCon, GameInfoOuter, HeadTitleCon, TextCon } from './styles'
import { Img } from '../../../../Components/Image/Img'
import { ANALYTICS_TAGS } from 'Constant'

export type GameInfoProps = {
  eventInfo: EventGQL | null
}

export const GameInfo: React.FC<React.PropsWithChildren<GameInfoProps>> = ({
  eventInfo,
}) => {
  const createStatsUrl = (eventId: string) => {
    return `${PLL_LINKS.stats}/games/${eventInfo?.year}/${eventId}`
  }
  return (
    <>
      {eventInfo && (
        <GameInfoOuter>
          <div className='left'>
            <HeadTitleCon>
              <p>
                {eventInfo.awayTeam?.fullName || 'TBA'} vs{' '}
                {eventInfo.homeTeam?.fullName || 'TBA'}
              </p>
            </HeadTitleCon>
            <div className='text'>
              {getShortDate(eventInfo.startTime)} •{' '}
              {getGameTimeLocal(eventInfo.startTime)} • {eventInfo.venue}
            </div>
            <TextCon>
              <p className='text'>Watch on:</p>
              {getReverseBroadcastImg(eventInfo.broadcaster).map((img, idx) => (
                <React.Fragment key={idx}>
                  {img && (
                    <BrocastLogoCon href={eventInfo.urlStreaming} key={idx} aria-label="Broadcaster logo">
                      <Img src={img} alt="Broadcaster logo" />
                    </BrocastLogoCon>
                  )}
                </React.Fragment>
              ))}
            </TextCon>
          </div>
          <div className='right'>
            {eventInfo.urlTicket && eventInfo.eventStatus === 0 && (
              <WhiteButtonLink
                href={eventInfo.urlTicket}
                analytics={{
                  event: ANALYTICS_TAGS.ticket_click,
                  params: {
                    page: 'matchups',
                    week: eventInfo.week,
                    event: eventInfo.id,
                    ticketUrl: eventInfo.urlTicket,
                  },
                }}
              >
                Tickets
              </WhiteButtonLink>
            )}
            {eventInfo.eventStatus === 1 && (
              <WhiteButtonLink
                href={eventInfo.urlStreaming}
                analytics={{
                  event: ANALYTICS_TAGS.watch_click,
                  params: {
                    page: 'matchups',
                    event: eventInfo.id,
                  },
                }}
              >
                Watch
              </WhiteButtonLink>
            )}
            {eventInfo.eventStatus >= 2 && (
              <WhiteButtonLink
                href={createStatsUrl(eventInfo.slugname)}
                analytics={{
                  event: ANALYTICS_TAGS.recap_click,
                  params: {
                    page: 'matchups',
                    event: eventInfo.id,
                  },
                }}
              >
                Recap
              </WhiteButtonLink>
            )}
          </div>
        </GameInfoOuter>
      )}
    </>
  )
}
